import { render, staticRenderFns } from "./PayEdit.vue?vue&type=template&id=2d00048c&scoped=true&"
import script from "./PayEdit.vue?vue&type=script&lang=js&"
export * from "./PayEdit.vue?vue&type=script&lang=js&"
import style0 from "../../less/pay.less?vue&type=style&index=0&id=2d00048c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d00048c",
  null
  
)

export default component.exports